var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPasswordIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 6.5V8.5C16.1 8.5 17 9.4 17 10.5V17.5C17 18.6 16.1 19.5 15 19.5H5C3.9 19.5 3 18.6 3 17.5V10.5C3 9.4 3.9 8.5 5 8.5V6.5C5 3.74 7.24 1.5 10 1.5C12.76 1.5 15 3.74 15 6.5ZM8 6.5V8.5H12V6.5C12 5.4 11.1 4.5 10 4.5C8.9 4.5 8 5.4 8 6.5ZM10.8 16.75V14.58C11.5 14.27 12 13.57 12 12.75C12 11.65 11.1 10.75 10 10.75C8.9 10.75 8 11.65 8 12.75C8 13.57 8.5 14.27 9.2 14.58V16.75H10.8Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordIcon);
export default __webpack_public_path__ + "static/media/password-icon.dcc7a3a5da79f9afed3f47bd32088949.svg";
export { ForwardRef as ReactComponent };